export const getSchoolNamesRoute = (userId) => `user/getschoolnames/${userId}`;
export const getSchoolClassRoute = () => '/school/class';
export const uploadPhotoRoute = () => '/file/upload';
export const sendMailRoute = () => 'communication/send/email';
